export const SM_WORKLIST_VALUES = 'SM_WORKLIST';
export const SM_WORKLIST_VALUES_NEW = 'SM_WORKLIST_NEW';
export const CRA_WORKLIST_VALUES = 'CRA_WORKLIST';
export const PI_WORKLIST_VALUES = 'PI_WORKLIST';
export const PI_WORKLIST_NEW_VALUES = 'PI_WORKLIST_NEW';
export const SCHEDULING_WORK_LIST_FILTERS = 'SCHEDULING_WORKLIST';
export const EXISTING_BUDGETS = 'EXISTING_BUDGETS';
export const REIMBURSEMENT_WORKLIST = 'REIMBURSEMENT_WORKLIST';
